module.exports = __webpack_public_path__ + "assets/9fe5d295707df24e10c008370cb2e757.png";